<template>
  <div class="grid grid--widebookmarks">
    <div class="xs-12 m-4 l-3 bookmarks__sidebar">
      <component :is="sidebarComponent" v-if="showSidebar" :bookmark-types="bookmarkTypes"></component>
      <Buttons
        v-if="!showSidebar"
        class="dea-button--medium dea-button--full dea-button--show-filters"
        @click="showSidebar = true"
      >
        Mostra filtri
      </Buttons>
      <Buttons
        v-if="showSidebar"
        class="dea-button--medium dea-button--full dea-button--hide-filters"
        @click="showSidebar = false"
      >
        Nascondi filtri
      </Buttons>
    </div>
    <div class="xs-12 m-8 l-9 bookmarks__list">
      <header class="bookmarks__header">
        <h2 class="bookmarks__title dea-heading--medium-xxl" tabindex="0">{{ mainTitle }}</h2>
        <InputSelect
          v-if="events.length"
          v-model="selectedFilter"
          class="dea-input--margin-responsive"
          placeholder="Filtra per tipologia"
        >
          <option v-for="type in eventTypes" :key="type.id" :value="type.id" :selected="selectedFilter === type.id">{{
            type.name
          }}</option>
        </InputSelect>
      </header>
      <EventsList
        v-if="events.length"
        :items="eventsFiltered"
        @save-bookmark="addBookmark"
        @delete-bookmark="removeBookmark"
      />
      <EmptyEvents v-else :link-color="user.targetCss.colorMod" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InputSelect from "@/components/elements/InputSelect";
import EventsList from "deascuola-storybook/src/components/patterns/EventsList";
import Buttons from "deascuola-storybook/src/components/elements/Buttons";
import handleWindowResize from "deascuola-storybook/src/components/mixins/handleWindowResize";
import BookmarkActions from "~/components/bookmarks/mixins/BookmarkActions";
import EmptyEvents from "~/components/bookmarks/components/EmptyEvents";
import BookmarkTypeView from "~/components/bookmarks/mixins/BookmarkTypeView";
import setFocus from "~/helpers/setFocus";

export default {
  name: "BookmarksEvents",
  components: { EventsList, InputSelect, EmptyEvents, Buttons },
  mixins: [BookmarkActions, handleWindowResize, BookmarkTypeView],
  data() {
    return {
      selectedFilter: null,
    };
  },
  computed: {
    ...mapGetters(["events", "eventsFiltered", "config"]),
    eventTypes() {
      const typesList = this.events.map(item => {
        return { id: item.type, name: item.type_label };
      });
      // make list unique: they are objects so the must be compared by their string representation
      return Array.from(new Set(typesList.map(object => JSON.stringify(object)))).map(string => JSON.parse(string));
    },
  },
  watch: {
    selectedFilter() {
      this.filterEventsByType(this.selectedFilter);
    },
  },
  mounted() {
    setFocus("bookmarks__title");
  },
  activated() {
    setFocus("bookmarks__title");
  },
  methods: {
    ...mapActions(["filterEventsByType"]),
  },
};
</script>
